import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import TwoFactorAuthStatuses from '../../constants/TwoFactorAuthStatuses';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const PREFIX = 'login.confirmToLogin.errors';
const ConfirmToLoginError = ({
  error,
  keyWord,
  vettingUrl
}) => {
  if (!error || keyWord !== 'confirmToLogin') {
    return null;
  }
  const i18nKey = `${PREFIX}.${error}`;
  return /*#__PURE__*/_jsx(Alert, {
    use: "inline",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${i18nKey}.title`
    }),
    type: "danger",
    "data-error-type": error,
    marginBlockEnd: "200",
    children: /*#__PURE__*/_jsx(Text, {
      textAlign: "start",
      children: vettingUrl && error === TwoFactorAuthStatuses.DEACTIVATED_USER ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `${i18nKey}.vetting_body_jsx`,
        options: {
          href: vettingUrl
        },
        elements: {
          Link
        }
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `${i18nKey}.body`
      })
    })
  });
};
export default ConfirmToLoginError;